/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ContractStatus {
    InBearbeitung = 'InBearbeitung',
    Beantragt = 'Beantragt',
    VorlaeufigeDeckung = 'VorlaeufigeDeckung',
    Aktiv = 'Aktiv',
    Gekuendigt = 'Gekuendigt',
    Suspendiert = 'Suspendiert',
    Abgelaufen = 'Abgelaufen',
    Storniert = 'Storniert'
  }

    export const ContractStatusTranslocoMap: Record<ContractStatus, string> = {
    [ContractStatus.InBearbeitung]: 'contractStatus.inBearbeitung',
    [ContractStatus.Beantragt]: 'contractStatus.beantragt',
    [ContractStatus.VorlaeufigeDeckung]: 'contractStatus.vorlaeufigeDeckung',
    [ContractStatus.Aktiv]: 'contractStatus.aktiv',
    [ContractStatus.Gekuendigt]: 'contractStatus.gekuendigt',
    [ContractStatus.Suspendiert]: 'contractStatus.suspendiert',
    [ContractStatus.Abgelaufen]: 'contractStatus.abgelaufen',
    [ContractStatus.Storniert]: 'contractStatus.storniert',
    };

    export const ContractStatusOptions = [
  { value: ContractStatus.InBearbeitung, labelKey: 'contractStatus.inBearbeitung' },
  { value: ContractStatus.Beantragt, labelKey: 'contractStatus.beantragt' },
  { value: ContractStatus.VorlaeufigeDeckung, labelKey: 'contractStatus.vorlaeufigeDeckung' },
  { value: ContractStatus.Aktiv, labelKey: 'contractStatus.aktiv' },
  { value: ContractStatus.Gekuendigt, labelKey: 'contractStatus.gekuendigt' },
  { value: ContractStatus.Suspendiert, labelKey: 'contractStatus.suspendiert' },
  { value: ContractStatus.Abgelaufen, labelKey: 'contractStatus.abgelaufen' },
  { value: ContractStatus.Storniert, labelKey: 'contractStatus.storniert' },
    ];

